import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, SelectSeparator } from "@/components/ui/select";
import { catLabel } from "@/lib/lore";

export const speakerSort = (entities) => [...entities].sort((a, b) => (a.category === "Character" ? 0 : 1) - (b.category === "Character" ? 0 : 1) || a.name.localeCompare(b.name));

export const SpeakerSelect = ({ entities, value, onChange, extra = [], testid, className = "h-9" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={`min-w-0 ${className}`} data-testid={testid}><SelectValue placeholder="Choose speaker" /></SelectTrigger>
    <SelectContent>
      {extra.map((x) => <SelectItem key={x.value} value={x.value}>{x.label}</SelectItem>)}
      {extra.length > 0 && <SelectSeparator />}
      {speakerSort(entities).map((e) => (
        <SelectItem key={e.id} value={`link:${e.id}`}>{e.name} <span className="text-[#A8A090]">· {catLabel(e.category)}</span></SelectItem>
      ))}
    </SelectContent>
  </Select>
);
